export default __webpack_public_path__ + "easydl-wavesummit294203.jpg";